// extracted by mini-css-extract-plugin
export default {"leadingVisual":"IssueTypePickerItemLeadingVisual-module__leadingVisual--pvUWN"};